import React from "react";
import { TextField, TextFieldProps } from "@mui/material";

interface FormTextFieldProps extends Omit<TextFieldProps, "error"> {
  name: string;
  errors?: string[];
  touched?: boolean;
}

/**
 * MUI TextField wrapper that handles Django-style form errors
 * Replaces Django TextInput, EmailInput, PasswordInput widgets
 */
export default function FormTextField({
  name,
  errors = [],
  touched = false,
  ...textFieldProps
}: FormTextFieldProps): React.ReactElement {
  const hasError = touched && errors.length > 0;

  return (
    <TextField
      {...textFieldProps}
      name={name}
      error={hasError}
      helperText={
        hasError ? errors.join(", ") : textFieldProps.helperText || ""
      }
      fullWidth
      variant="outlined"
      margin="normal"
    />
  );
}
